import { NavData } from './../../models/eventNavigation.model';

import { Component } from '@angular/core';
import {
  ModalController,
  NavController,
  NavParams,
  Events,
} from '../../../node_modules/ionic-angular';

@Component({
  selector: 'event-navigation-button',
  templateUrl: 'event-navigation-button.html',
})
export class EventNavigationButtonComponent {
  constructor(
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public navParams: NavParams,
    private events: Events
  ) {}

  openNavigation() {
    let myModal = this.modalCtrl.create('EventNavigationPage', null, {
      cssClass: 'event-navigation-btn',
    });
    myModal.onDidDismiss((data?: NavData) => {
      console.log('Ovo je data =>', typeof data);
      if (typeof data != 'undefined') {
        console.log('Ovo je data =>', data);
        this.navCtrl.parent.select(data.page);
      }
    });
    myModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/components/event-navigation-button/event-navigation-button.ts